import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../../Heading';

const ModalHeading = ({ className, size = 'large', ...restProps }) => (
  <Heading {...restProps} size={size} className={className} />
);

ModalHeading.propTypes = Heading.propTypes;

export default ModalHeading;
